// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleAnimation-module--container--D6p0G","element":"TitleAnimation-module--element--uzf8p","visible":"TitleAnimation-module--visible--9_cNk"};